document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.videoPlay');

  videos.forEach((video) => {
    const isAutoplay = video.dataset.autoplay === 'true';
    const buttons = document.querySelectorAll(`[aria-controls="${video.id}"]`);

    if (isAutoplay) {
      video.play().catch(() => {});
    } else {
      video.preload = 'metadata';
      video.pause();
      video.currentTime = 0;
    }

    const updateButtonStates = () => {
      buttons.forEach((button) => {
        const playIcon = button.querySelector('[data-icon-play]');
        const pauseIcon = button.querySelector('[data-icon-pause]');
        if (playIcon) playIcon.hidden = !video.paused;
        if (pauseIcon) pauseIcon.hidden = video.paused;
      });
    };

    updateButtonStates();

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
        updateButtonStates();
      });
    });
  });
});
